import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../../../../services/popup.service';
import { MapService } from '../../../../../services/map.service';
import { MyStuffService } from '../../../../../services/my-stuff.service';
import { NotificationService } from '../../../../../services/notification.service';
import { UserService } from '../../../../../services/user.service';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-maps-received',
  templateUrl: './maps-received.component.html',
  styleUrls: ['./maps-received.component.less']
})
export class MapsReceivedComponent implements OnInit {
  GOOLGE_CLIENT_ID = environment.APP.GOOGLE_CLIENT_ID;
  API_URL = environment.APP.API_URL;
  mapsDetailElement: any;
  isDropdownOpen: any = {};

  constructor(public popupService: PopupService, public mapService: MapService,
   public myStuffService: MyStuffService, public notificationService: NotificationService,
   public userService: UserService) { }

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.receivedMaps) {
      this.myStuffService.fetchReceivedMapsSource.next(true);
      this.myStuffService.myStuffSectionOpened.receivedMaps = true;
    }
  }

  openDropdown(index) {
    this.closeAllDropdowns();
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
    (<any>window).Events.publish('detectChanges')
  }

  closeAllDropdowns() {
    Object.keys(this.isDropdownOpen).map((index)=>{
      if(this.isDropdownOpen[index]) {
        this.isDropdownOpen[index] = false;
      }
    });
  }

  closeDropdown(index) {
    this.isDropdownOpen[index] = !this.isDropdownOpen[index];
    (<any>window).Events.publish('detectChanges')

  }

  paginate() {
    if(this.mapService.userMaps.received.length > 0) {
      this.myStuffService.getMaps(this.myStuffService.mapCallFilters.received);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/maps-section/maps-received/maps-received.component.ts